import { HomePageTabId, PRODUCT_CATEGORIES } from '../constants/productCategories';

export type SearchableProduct = {
  name: string;
  category: string;
  categoryId?: string;
  vendorName?: string;
  sku?: string;
};

export function matchesProductCategory(
  product: SearchableProduct,
  categoryId: HomePageTabId
): boolean {
  if (product.categoryId === categoryId) {
    return true;
  }

  const category = PRODUCT_CATEGORIES.find((item) => item.id === categoryId);
  if (!category) {
    return false;
  }

  const searchTerms = [category.id, category.name, category.tabLabel];
  const productCategory = product.category.toLowerCase();
  return searchTerms.some((term) => productCategory.includes(term.toLowerCase()));
}

export function matchesProductQuery(product: SearchableProduct, query: string): boolean {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return true;
  }

  const haystack = [product.name, product.category, product.vendorName, product.sku]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  const terms = normalized.split(/\s+/).filter(Boolean);
  return terms.every((term) => haystack.includes(term));
}

export function filterProductsByCategory<T extends SearchableProduct>(
  products: T[],
  categoryId: HomePageTabId | 'all'
): T[] {
  if (categoryId === 'all') {
    return products;
  }
  return products.filter((product) => matchesProductCategory(product, categoryId));
}

export function filterProductsByQuery<T extends SearchableProduct>(
  products: T[],
  query: string
): T[] {
  if (!query.trim()) {
    return products;
  }
  return products.filter((product) => matchesProductQuery(product, query));
}
